import { useCurrentPurchaseIntent } from "@/features/my/checkout/_api/use-current-purchase-intent";
import { useUpdatePurchaseIntent } from "@/features/my/checkout/_api/use-update-purchase-intent";
import {
  OfferStatusRow,
  type PurchaseIntentPriceDetail,
} from "@/features/shared/checkout-summary";

export const AppliedPromoCode = () => {
  const {
    data: purchaseIntent,
    isFetching: isFetchingPurchaseIntent,
    refetch: refetchPurchaseIntent,
  } = useCurrentPurchaseIntent();

  const purchaseIntentPayload: any = purchaseIntent?.payload;
  const priceData: PurchaseIntentPriceDetail | undefined =
    purchaseIntentPayload?.priceDetail;

  const {
    mutateAsync: updatePurchaseIntent,
    isPending: isUpdatingPurchaseIntent,
  } = useUpdatePurchaseIntent();

  const handleRemovePromoCode = async () => {
    if (isUpdatingPurchaseIntent || !purchaseIntent?.id) return;
    await updatePurchaseIntent({
      purchaseIntentId: purchaseIntent?.id,
      updatePurchaseIntentInput: {
        discountCode: null,
      },
    });
    await refetchPurchaseIntent();
  };

  // The amount is deliberately absent here — it is the ledger's `Offer discount` row.
  return (
    <OfferStatusRow
      code={purchaseIntentPayload?.discountCode ?? ""}
      description={priceData?.discount?.shortDescription}
      onRemove={handleRemovePromoCode}
      isRemoving={isUpdatingPurchaseIntent || isFetchingPurchaseIntent}
    />
  );
};
